<!--suppress ALL -->
<script lang="ts">
import {jenisTransfer} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";
  import AppConfig from "../../../AppConfig";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class JenisTransferSelect extends Vue {

    @Prop({default: jenisTransfer[0].value, type: String})
    private jenis: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({default: false, type: Boolean})
    public disabled: boolean;

    @Prop({
      default: () => AppConfig.getVm().$t('label.jenis_transfer').toString(),
      type: String
    })
    public label: string;

    @Prop({type: String, default: ""})
    public message: string;

    @Prop({type: String, default: ""})
    public type: string;

    public onSelectJenisTransfer(param: string) {
      this.$emit('update:jenis', param || jenisTransfer[0].value);
      this.$emit('kelamin-selected', param);
    }

    public render(createElement: Function) {
      const {$t, jenis, isFullwidth, label, message, type} = this;

      const mainAttr: any = {
        attrs: {disabled: this.disabled},
        props: {
          value: jenis, isFullwidth,
          placeholder: `${$t('label.choose')} ${label}`
        },
        on: {change: this.onSelectJenisTransfer}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(jenisTransfer).map((item: any) => {
        const option: any = {key: item.value, attrs: {value: item.value}};

        return createElement('option', option, item.label);
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label, message, type}}, [main]);
    }
  }
</script>
